import Header from "./components/Header/Header";
import "./App.css";
import Hero from "./components/UI/Hero";
import Counter from "./components/UI/Counter";
import Services from "./components/UI/Services";
import About from "./components/UI/About";
import Testimonial from "./components/UI/Testimonial";
import Footer from "./components/UI/Footer";
import i18next from "i18next";

function App() {
  document.body.dir = i18next.dir();

  return (
    <>
      <Header />
      <Hero />
      {/* <Counter /> */}
      <Services />
      <About />
      <Testimonial />
      <Footer />
    </>
  );
}

export default App;
